import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmail from 'validator/es/lib/isEmail';

const validate = {
	notEmpty: value => (value ? '' : i18n.t('FieldMustBeFilled')),
	notEmptyEmail: value => (value ? '' : i18n.t('EnterEmail')),
	email: value => (isEmail(value) && value.search(/[А-яЁё]/) === -1 ? '' : i18n.t('EnterCorrectEmail')),
};

export default class Input extends React.PureComponent {
	static propTypes = {
		autoComplete: PropTypes.oneOf(['on', 'off']),
		isAutofocused: PropTypes.bool,
		isDisabled: PropTypes.bool,
		isValid: PropTypes.bool,
		maxLength: PropTypes.number,
		name: PropTypes.string,
		onChange: PropTypes.func.isRequired,
		onValidate: PropTypes.func,
		placeholder: PropTypes.string,
		type: PropTypes.oneOf(['text', 'number', 'file', 'hidden', 'password', 'reset', 'email']),
		value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		validators: PropTypes.arrayOf(PropTypes.oneOf(['notEmpty', 'email', 'notEmptyEmail'])),
	}

	static defaultProps = {
		autoComplete: 'off',
		isAutofocused: false,
		isDisabled: false,
		isValid: true,
		maxLength: null,
		name: '',
		onValidate: null,
		placeholder: '',
		type: 'text',
		value: '',
		width: null,
		validators: [],
	}

	state = {
		validationError: '',
	}

	componentDidMount = () => {
		const {isAutofocused} = this.props;
		if (isAutofocused) {
			this._inputNode.focus();
		}
	}

	handleChange = (event) => {
		const {onChange} = this.props;
		onChange(event.target);
	}

	handleBlur = () => {
		const {validators, value, onValidate} = this.props;

		if (validators && validators.length) {
			const validationError = _.reduce(
				validators,
				(error, validator) => {
					if (!error && validate[validator](value)) {
						return validate[validator](value);
					}

					return error;
				},
				'',
			);

			if (validationError) {
				this.setState({validationError});
			}

			if (typeof onValidate === 'function') {
				onValidate(validationError);
			}
		}
	}

	handleFocus = () => {
		const {validators, onValidate} = this.props;

		if (validators && validators.length) {
			this.setState({validationError: ''});

			if (typeof onValidate === 'function') {
				onValidate('');
			}
		}
	}

	render() {
		const {
			placeholder, type, name, autoComplete, width, value, isDisabled, isValid, maxLength,
		} = this.props;
		const {validationError} = this.state;
		const inputClasses = classNames('input', {
			'input--has-error': !isValid || validationError,
			'input--disabled': isDisabled,
		});

		return (
			<div className="input-container">
				<input
					autoComplete={autoComplete}
					className={inputClasses}
					disabled={isDisabled}
					maxLength={maxLength}
					onChange={this.handleChange}
					name={name}
					placeholder={placeholder}
					onBlur={this.handleBlur}
					onFocus={this.handleFocus}
					ref={node => { this._inputNode = node; }}
					style={{width}}
					type={type !== 'number' ? type : 'text'}
					value={value}
				/>
				{validationError ?
					<div className="input__error">{validationError}</div>
					: null}
			</div>
		);
	}
}
